import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@bp-core/src/lib/services/portal/auth.service';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { PortalConfigParamService } from '../services/portal-config-param.service';

@Injectable({
  providedIn: 'root',
})
export class StocksEnabledGuard implements CanActivate {
  constructor(
    private portalConfigParamService: PortalConfigParamService,
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.getCurrentUser().pipe(
      take(1),
      switchMap(user =>
        this.portalConfigParamService
          .isStocksFlowEnabled(user)
          .pipe(map(enabled => (enabled ? true : this.router.createUrlTree(['/dashboard'])))),
      ),
    );
  }
}
